import classNames from 'classnames';
import type { FC } from 'react';
import { badge } from '../Pricing.css';

type RecommendedBadgeProps = {
  text?: string;
};

const RecommendedBadge: FC<RecommendedBadgeProps> = ({ text = 'Recommended' }) => {
  return (
    <div className={classNames('w-fit sm:absolute sm:-top-4 sm:left-1/2 sm:transform sm:-translate-x-1/2')}>
      <div
        className={classNames(
          'text-sm font-medium flex items-center justify-center px-2 py-1 w-fit whitespace-nowrap',
          badge,
        )}
      >
        {text}
      </div>
    </div>
  );
};

export { RecommendedBadge };
